"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  isPrimeSwap: true,
  isPrimeSwapV1: true,
  isNftSwap: true,
  isNftStrictSwap: true,
  parsePeriodLength: true
};
exports.isNftStrictSwap = isNftStrictSwap;
exports.isNftSwap = isNftSwap;
exports.isPrimeSwap = isPrimeSwap;
exports.isPrimeSwapV1 = isPrimeSwapV1;
exports.parsePeriodLength = parsePeriodLength;
var _schema = require("./schema");
Object.keys(_schema).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _schema[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _schema[key];
    }
  });
});
function isPrimeSwap(swap) {
  return swap && "value" in swap && "stakeTime" in swap;
}
function isPrimeSwapV1(swap) {
  return swap && "value" in swap && !("stakeTime" in swap);
}
function isNftSwap(swap) {
  return swap && "tokenIds" in swap && "fromChain" in swap;
}
function isNftStrictSwap(swap) {
  return swap && "tokenIds" in swap && "fromChainId" in swap;
}
function parsePeriodLength(data) {
  let split = data.split(" ");
  let num = parseInt(split[0]);
  let unit = split[1];
  switch (unit) {
    case "hours":
      return num * 60 * 60;
    default:
      return num * 24 * 60 * 60;
  }
}
//# sourceMappingURL=index.js.map